import { render } from "./ListaHotspots.vue?vue&type=template&id=25d687a0"
import script from "./ListaHotspots.vue?vue&type=script&lang=js"
export * from "./ListaHotspots.vue?vue&type=script&lang=js"

import "./ListaHotspots.vue?vue&type=style&index=0&id=25d687a0&lang=css"

import exportComponent from "/home/jean/lienzo/quinta_amelia_dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__